/**
 * PrimeNG paginator / advanced-data-table: `event.page` is 0-based.
 * Many OMS list screens keep UI state as 1-based `page` + `size`.
 */

export type PrimePaginatorPageChange = {
  page?: number;
  rows?: number;
};

export function mergeOneBasedPageFromPrimeEvent<T extends { page: number; size: number }>(
  current: T,
  event: PrimePaginatorPageChange,
): T {
  const page = (event.page ?? 0) + 1;
  const size = event.rows ?? current.size;
  return { ...current, page, size };
}
